// src/pages/QRCodePage.jsx
import React, { useEffect, useState } from "react";
import api from "../api";

import { QRCodeCanvas } from "qrcode.react";
import { Box, Paper, Typography, Button, Grid, Alert } from "@mui/material";

/**
 * CLIENT automatically detects the current host + port.
 * Works on:
 *  - Local PC
 *  - Any LAN IP
 *  - Offline Router
 *  - Portable Deployment
 */
const CLIENT = window.location.origin;

export default function QRCodePage() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError]   = useState("");

  const load = async () => {
    try {
      setLoading(true);
      setError("");

      // 🔥 Fully relative API - no IP hardcoding
      const res = await api.get(`/api/artifacts`);
      setItems(res.data);
    } catch (err) {
      console.error(err);
      setError("Failed to load artifacts. Please check WiFi / Server.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
  }, []);

  const download = (id, title) => {
    const canvas = document.querySelector(`#qr-${id} canvas`);
    if (!canvas) return alert("QR code not ready");

    const url = canvas.toDataURL("image/png");
    const a = document.createElement("a");
    a.href = url;
    a.download = `${title || "qr-code"}.png`;
    a.click();
  };

  if (loading)
    return (
      <Typography sx={{ textAlign: "center", mt: 4 }}>
        Generating QR codes…
      </Typography>
    );

  return (
    <Box>
      <Typography variant="h5" gutterBottom>
        QR Codes
      </Typography>

      {error && (
        <Alert severity="error" sx={{ mb: 2 }}>
          {error}
          <Button
            variant="outlined"
            size="small"
            sx={{ ml: 2 }}
            onClick={load}
          >
            Retry
          </Button>
        </Alert>
      )}

      <Grid container spacing={2}>
        {!error &&
          items.map((a) => (
            <Grid item xs={12} sm={6} md={4} key={a._id}>
              <Paper sx={{ p: 2, textAlign: "center" }}>
                <Typography variant="subtitle1" gutterBottom>
                  {a.title}
                </Typography>

                <div id={`qr-${a._id}`} style={{ display: "inline-block" }}>
                  <QRCodeCanvas
                    value={`${CLIENT}/info/${a._id}`}   // 👈 Auto works everywhere
                    size={160}
                  />
                </div>

                <Box sx={{ mt: 1 }}>
                  <Button
                    variant="outlined"
                    onClick={() => download(a._id, a.title)}
                  >
                    Download
                  </Button>
                </Box>
              </Paper>
            </Grid>
          ))}

        {!error && items.length === 0 && (
          <Grid item xs={12}>
            <Typography>No artifacts found.</Typography>
          </Grid>
        )}
      </Grid>
    </Box>
  );
}
